import React from 'react'

const Footer = () => {
    return (
        <footer className="footer">
            Copyright &copy; 2020 | Made by&nbsp;
            <a
                href="https://www.linkedin.com/in/kumarsks619"
                target="_blank"
                rel="noopener noreferrer"
            >
                VeNoM
            </a>
        </footer>
    )
}

export default Footer
